/* global console window require document */

import page from "page"; // window global

import $ from "jquery";
import Vue from "vue";

import { trans } from "common/translate.js";

import { EventBus } from "./event-bus.js";

// The sidebar bits (searching, showing filters etc.)
import "./search-sidebar.js";
// A search result in a search page
import "./manuscript-result.js";
// A single result in a manuscript
import "./image-result.js";
// Help toggle button
import "./help-tooltip-toggle.js";
// Mobile sidebar
import "./mobile-search-sidebar.js";
// Status indicator
import "./status.js";
// Tablist for comments, notes etc.
import "./tablist.js";

export default Vue.component("search-page", {
  data() {
    return {
      isManuscript: page === "manuscript",
      query: "",
      pages: [],
      loading: false,
      failed: false,
      manuscriptModel: {},
      numComments: {},
      trans
    };
  },

  // Component methods
  methods: {
    // This method gets a page and feeds it back into the vue component.
    getPage(n) {
      // Abort if already loading
      if (this.loading) {
        return;
      }

      const apiRequestPath =
        this.isManuscript ?
        `/api/search?t=image&${this.query.replace(/&/g, "%26")}&p=${n || 1}`
        : `/api/search?t=manuscript&${this.query.replace(/&/g, "%26")}&p=${n || 1}`;
      console.log(`Requesting api path: ${apiRequestPath}`);

      // Check if this is internet explorer 11. Due to the way IE11 handles URLs,
      const isIE = !!window.MSInputMethodContext && !!document.documentMode;

      this.loading = true;
      $.getJSON(isIE ? encodeURI(apiRequestPath) : apiRequestPath)
        .done((data) => {
          if ((n || 1) === 1) {
            this.pages = [];
          }
          this.pages.push(data);
          this.loading = false;
          this.getCommentsForItems(this.missingItemsIds);
        })
        .fail(() => {
          this.failed = true;
        });
    },

    getNextPage() {
      this.getPage(this.maxPage + 1);
    },

    getCommentsForItems(itemIds) {
      // Fetches comments for itemIds (as an array)
      const disqusApiRequestPath =
        "/api/disqus?endpoint=/threads/list.json&" +
        itemIds
          .map(e => `thread[]=ident:${this.isManuscript ? "image" : "manuscript"}/${e}`)
          .join("&");

      $.getJSON(disqusApiRequestPath)
        .done((data) => {
          const commentTupleArr = data.response.map((response) => {
            // Return a single tuple
            console.log(response);
            return [ response.identifiers.join("").replace(this.isManuscript ? "image/" : "manuscript/", ""), response.posts ];
          });

          // Populate numComments from the received tuple array
          const newNumComments = {};
          commentTupleArr.forEach((data) => {
            newNumComments[data[0]] = data[1];
          });

          this.numComments = Object.assign(newNumComments, this.numComments);
          console.log(this.numComments);
        });
    },

    queryAsArray() {
      // Init with the free text part of the search
      const queryParts = [ `'${this.firstValidPage.freetext}'` ];

      // Populate an array with the current facets
      const currentFacets = this.firstValidPage.subqueries
        .map(e => `${e.fieldname}:'${e.text}'`);

      // Add the array of current facets to the query array
      queryParts.push.apply(queryParts, currentFacets); // In place concat

      return queryParts;
    },

    queryWithFilter(filterField, filterText) {
      const queryParts = this.queryAsArray();

      // Also add what we're trying to add to the query
      queryParts.push(`${filterField}:'${filterText}'`);

      // Join and return
      this.query = "q=" + queryParts.join("+AND+");
    },

    queryWithoutFilter(filterField, filterText) {
      // Find and remove the query
      const queryParts = this.queryAsArray()
        .filter((e) => e !== `${filterField}:'${filterText}'`);

      // Join and return
      this.query = "q=" + queryParts.join("+AND+");
    },

    queryWithFreetext(freetext) {
      // Get a copy of the computed prop
      const queryParts = this.queryAsArray();
      // Modify the first part of the array (alwyas the free text)
      queryParts[0] = `'${freetext}'`;

      // Join and return
      this.query = "q=" + queryParts.join("+AND+");
    },

    checkEmptyQuery() {
      if (this.query == "q=" || this.query == "q=''" || this.query == "") {
        // Redirect back if query is empty
        console.log("Query empty. Navigating back to search page");
        window.location = "/explore-the-archive";
      }
    }
  },

  computed: {
    flatResults() {
      if (this.pages.length >= 0) {
        return this.pages.map(a => a.results).reduce((a, b) => {
          return a.concat(b);
        });
      } else {
        return [];
      }
    },

    allItemsIds() {
      return this.flatResults.map(e => this.isManuscript ? e.name : e.manuscript_id);
    },

    missingItemsIds() {
      const keys = Object.keys(this.numComments);
      return this.allItemsIds.filter((e) => keys.indexOf(e) === -1);
    },

    firstValidPage() {
      return this.pages.find((p) => p instanceof Object);
    },

    totalResults() {
      // Total number of results in the query
      const validP = this.firstValidPage;
      if (validP !== undefined) {
        return validP.length;
      } else {
        return -1;
      }
    },

    totalPages() {
      // Total number of pages in query
      const validP = this.firstValidPage;
      if (validP !== undefined) {
        return validP.totalpages;
      } else {
        return -1;
      }
    },

    currentResults() {
      // How many results have been fetched overall?
      return this.pages.map((e) => {
        if (e !== undefined) {
          return e.results.length;
        } else {
          return 0;
        }
      }).reduce((a, b) => a + b, 0);
    },

    maxPage() {
      // The farthest page reached
      return this.pages.length !== 0 ? Math.max(...this.pages.map(p => p.page)) : 0;
    },

    state() {
      // The current state based on current conditions
      if (this.pages.length === 0 && !this.failed) {
        return "INITIAL_LOADING";
      } else if (this.pages.length !== 0 && !this.loading && !this.failed && this.totalResults == 0) {
        return "NO_RESULTS";
      } else if (this.pages.length !== 0 && this.loading && !this.failed) {
        return "LOADING_MORE";
      } else if (this.pages.length !== 0 && !this.loading && !this.failed) {
        return "IDLE";
      } else if (this.failed) {
        return "ERROR";
      } else {
        return "UNKNOWN";
      }
    },

    hasMorePages() {
      return this.state !== "NO_RESULTS"
        && this.state !== "ERROR"
        && this.state !== "UNKNOWN"
        && this.state !== "INITIAL_LOADING"
        && this.maxPage < this.totalPages;
    }
  },

  watch: {
    query() {
      // This will only trigger if query has ACTUALLY changed!
      console.log("Query has changed. Reloading.");
      this.failed = false;

      // Get the first page
      this.getPage(1);

      if (!this.isManuscript) {
        this.checkEmptyQuery();
        window.location.hash = this.query;
      }
    }
  },

  // On creation
  created() {
    if (this.isManuscript) {
      // Get the manuscript number from `window.manuscriptNumber`. This is used
      // to initialize the query
      this.manuscriptModel = require("manuscriptModel");
      this.query = `q=manuscript_numbers:'${this.manuscriptModel.manuscript_number}'`;
    } else {
      console.log("Search page created");

      // Bind hash change event
      $(window).on("hashchange", () => {
        const newQuery = window.location.hash.slice(1);
        // Ensure that a query change doesn't set off due to different parsing
        // of the hash (URI encoded vs. not)
        this.query = decodeURI(newQuery);
      });
      console.log(`Search query set to: ${window.location.hash.slice(1)}`);
      // Trigger a change of query.
      this.query = window.location.hash.slice(1);

      this.checkEmptyQuery();
    }

    // Bind global bus events.
    EventBus.$on("query-with-freetext", value => {
      this.queryWithFreetext(value);
    });

    EventBus.$on("query-with-filter", value => {
      this.queryWithFilter(value[0], value[1]);
    });

    EventBus.$on("query-without-filter", value => {
      this.queryWithoutFilter(value[0], value[1]);
    });

  },

  mounted() {
    document.addEventListener("keydown", event => {
      if (event.keyCode == 27) {
        EventBus.$emit("esc-pressed");
      }
    });
  },

  template: require("./templates/search-page.html")
});



// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/search-page.js